import clsx from 'clsx'
import { ReactComponent as ChevPrev } from 'assets/icons/chev-prev.svg'
import { ReactComponent as ChevNext } from 'assets/icons/chev-next.svg'

const PaginationBar = ({ total, page, onChange, limit }) => {
  const lastPage = Math.ceil(total / limit)
  const lookBehind = page === lastPage ? 2 : 1
  const startingPoint = Math.max(2, page - lookBehind)
  const renderLength = page === 1 ? 2 : 1
  const endingPoint = Math.min(page + renderLength, lastPage - 1)
  const pages = []

  for (let i = startingPoint; i <= endingPoint; i++) {
    pages.push(i)
  }

  const buttonClasses = 'h-[20px] w-[20px] flex justify-center items-center'
  const buttonInactive = clsx(buttonClasses, 'text-white opacity-50')
  const buttonActive = clsx(buttonClasses, 'text-pink font-bold')

  return (
    <div className="w-full h-[50px] bg-gray-dark drop-shadow-dark flex flex-row justify-center items-center">
      <button
        className={clsx(buttonClasses, {
          'opacity-50': page === 1,
        })}
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
      >
        <ChevPrev fill={page === 1 ? '#FFF' : '#d63b5c'} />
      </button>
      <button
        className={page === 1 ? buttonActive : buttonInactive}
        onClick={() => onChange(1)}
      >
        1
      </button>
      {startingPoint > 2 && <div className={buttonInactive}>...</div>}
      {pages.map((item) => (
        <button
          className={page === item ? buttonActive : buttonInactive}
          onClick={() => onChange(item)}
        >
          {item}
        </button>
      ))}
      {endingPoint < lastPage - 1 && <div className={buttonInactive}>...</div>}
      <button
        className={page === lastPage ? buttonActive : buttonInactive}
        onClick={() => onChange(lastPage)}
      >
        {lastPage}
      </button>
      <button
        className={clsx(buttonClasses, {
          'opacity-50': page === lastPage,
        })}
        onClick={() => onChange(page + 1)}
        disabled={page === lastPage}
      >
        <ChevNext fill={page === lastPage ? '#FFF' : '#d63b5c'} />
      </button>
    </div>
  )
}

export default PaginationBar
